import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { GameReviewPage } from "@/features/catalogue-review/GameReviewPage"
import {
	normaliseScope,
	ReviewScopeProvider,
} from "@/features/catalogue-review/review-scope"

const searchSchema = z.object({
	/** Expansion slugs the review is narrowed to; absent = the whole game. */
	expansions: z.array(z.string()).optional().catch(undefined),
})

export const Route = createFileRoute("/catalogue-v2/$gameSlug")({
	component: Page,
	validateSearch: searchSchema,
})

function Page() {
	const { gameSlug } = Route.useParams()
	const search = Route.useSearch()
	const navigate = Route.useNavigate()
	const expansionSlugs = normaliseScope(search.expansions)
	return (
		<ReviewScopeProvider expansionSlugs={expansionSlugs}>
			<GameReviewPage
				gameSlug={gameSlug}
				onScopeChange={(slugs) =>
					navigate({
						search: (prev) => ({
							...prev,
							expansions: normaliseScope(slugs),
						}),
						replace: true,
					})
				}
			/>
		</ReviewScopeProvider>
	)
}
